import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import type { UserManagerSettings } from 'oidc-client-ts';

export let isProd = ['app.tyro.school', 'new.tyro.school'].includes(
  window.location.hostname,
);

if (
  process.env.NODE_ENV === 'development' &&
  process.env.PUBLIC_AUTH_PROD === 'true'
) {
  isProd = true;
}

const authority = isProd
  ? 'https://auth.tyro.school/realms/tyro'
  : 'https://kc.tyro-dev.com/realms/tyro';

export const oidcConfig: UserManagerSettings = {
  authority,
  client_id: 'tyro-ui',
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

let userManager: UserManager | null = null;

export function getUserManager(): UserManager {
  if (!userManager) {
    userManager = new UserManager(oidcConfig);
  }
  return userManager;
}

export async function acquireAuthToken(): Promise<string | null> {
  const um = getUserManager();
  try {
    const user = await um.getUser();
    if (user && !user.expired) {
      return user.access_token;
    }
    const renewedUser = await um.signinSilent();
    return renewedUser?.access_token ?? null;
  } catch {
    await um.signinRedirect();
    return null;
  }
}
